import axios from "axios";

export function checkIn() {
  return axios.post("/v1/streak/check-in");
}

export function getStreakStatus() {
  return axios.get("/v1/streak/status");
}
